var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPiePledge(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "83px",
    height: "82px",
    viewBox: "0 0 83 82",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icPiePledge") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main-screens-Stage-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mobile-The-Pie-Pledge",
    transform: "translate(-146.000000, -125.000000)",
    fillRule: "nonzero",
    stroke: "#7BCB45",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(10.000000, 116.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icPiePledge",
    transform: "translate(137.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 21.6688742,
    cy: 14.3576159,
    r: 10.3311258
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0621923,0.0578905577 L43.74906,0.024320243 C39.4323071,-0.311382904 35.629986,2.86660689 35.1938374,7.18598738 C34.7465055,11.5836986 37.9449285,15.5002353 42.3399645,15.9478395 L42.4629808,15.9702197 C54.6975083,17.1339906 64.270411,27.4400773 64.270411,39.995375 C64.270411,53.3227899 53.4673455,64.1324312 40.1592215,64.1324312 C26.8510974,64.1324312 16.0368487,53.3227899 16.0368487,39.995375 C16.0368487,38.0594868 16.2493313,36.1683591 16.6854799,34.3667522 C17.5801437,30.0473717 14.8066859,25.8063219 10.4899331,24.9111136 C6.17318024,24.0159052 2.05772675,26.6008194 0.995313481,31.0209108 L0.950580291,31.1887624 C0.324315629,33.9974787 0,36.9292862 0,39.9282343 C0,50.3126517 3.94770403,59.7682903 10.4228333,66.8851971 L9.13675409,76.0610831 C9.13675409,76.0946534 9.12557079,76.1282237 9.12557079,76.161794 L9.11438749,76.2065544 L9.11438749,76.2065544 C9.1032042,76.3184555 9.0920209,76.4415466 9.0920209,76.5646378 C9.0920209,78.2655337 10.4675665,79.6307265 12.1562444,79.6307265 C12.6035763,79.6307265 13.0397249,79.5300156 13.419957,79.362164 L13.4311403,79.362164 L21.9080799,75.6582393 C27.3543458,78.4333853 33.527526,80 40.0585718,80 C62.1791343,80 80.1059603,62.0622618 80.1059603,39.9282343 C80.094777,19.1593996 64.3039608,2.07210944 44.0621923,0.0578905577 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPiePledge);
export default __webpack_public_path__ + "static/media/icPiePledge.bd37093a2d61544cf3573c5f46e5b1a6.svg";
export { ForwardRef as ReactComponent };